// Assessment accelerator activities
const CONSTRUCT_A_RESPONSE = 'construct-a-response';
const DRAG_AND_DROP_COMPARISON = 'drag-and-drop-comparison';
const DRAG_AND_DROP_CATEGORIES = 'drag-and-drop-categories';
const DRAG_AND_DROP_TABLE = 'drag-and-drop-table';
const DRAG_AND_DROP_BUILD_FRACTIONS = 'drag-and-drop-build-fractions';
const EQUATION_BUILDER = 'equation-builder';
const GRAPH_IT_TABLE = 'graph-it-table';
const GRAPH_IT_IMAGE = 'graph-it-image';
const HIGHLIGHT_IT = 'highlight-it';
const MULTI_SELECT = 'multi-select';
const PICK_THE_ANSWER = 'pick-the-answer';
const SELECT_IT = 'select-it';

const transformers = {
  transformActivity: activity => {
    const { variant } = activity.activityTypeVariant;
    switch (variant) {
      case CONSTRUCT_A_RESPONSE:
      case DRAG_AND_DROP_COMPARISON:
      case DRAG_AND_DROP_CATEGORIES:
      case DRAG_AND_DROP_TABLE:
      case DRAG_AND_DROP_BUILD_FRACTIONS:
      case EQUATION_BUILDER:
      case HIGHLIGHT_IT:
      case PICK_THE_ANSWER:
        return transformers.transformRoundInstructions(activity);
      case GRAPH_IT_TABLE:
      case GRAPH_IT_IMAGE:
        return transformers.transformGraphIt(activity);
      case MULTI_SELECT:
      case SELECT_IT:
        return transformers.transformOptionalImageAndInstructions(activity);
      default:
        return activity;
    }
  },
  transformOptionalImageAndInstructions: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ roundImage, roundInstructions, ...round }) => ({
      ...round,
      image: roundImage,
      instructions: roundInstructions
    }))
  }),
  transformGraphIt: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(
      ({ roundInstructions, optionalNumAnswers, optionalMainContent, ...round }) => ({
        ...round,
        instructions: roundInstructions,
        numAnswers: optionalNumAnswers,
        mainContent: optionalMainContent
      })
    )
  }),
  transformRoundInstructions: ({ rounds, ...data }) => ({
    ...data,
    rounds: rounds.map(({ roundInstructions, ...round }) => ({
      ...round,
      instructions: roundInstructions
    }))
  })
};

export default transformers;
